import React from 'react';
import { Col, Row } from 'antd';
import { filterStatus } from '../../../../../App/Enums';
import CButton from '../../../../../Assets/Components/CButton';
import Table, {
  generateColumnData,
} from '../../../../../Assets/Components/CTable';
import Select from '../../../../../Assets/Components/Select';

interface IProps {
  columnData: any;
  disabled: boolean;
  data: any;
  handleAdd: () => void;
  handleRefresh: () => void;
  handleApplyfilter: () => void;
  isLoading: any;
  setSelectedStatus: React.Dispatch<React.SetStateAction<any>>;
  selectedStatus?: any;
}

export default function FeedbackNonSelfLearningTabComponent(props: IProps) {
  const {
    columnData,
    disabled,
    isLoading,
    handleAdd,
    handleRefresh,
    data,
    handleApplyfilter,
    selectedStatus,
    setSelectedStatus,
  } = props;

  const buttonDataSearch = [
    {
      type: 'primary',
      className: 'spacingBtnSecondRow2 btnRadius10',
      icon: 'SearchOutlined',
      content: 'Cari',
      id: 'btnSearchList',
      onClick: handleApplyfilter,
      disabled,
    },
  ];

  const buttonData = [
    {
      type: 'primary',
      className: 'spacingBtnSecondRow2 btnRadius10',
      icon: null,
      content: 'Tambah Baru',
      id: 'btnAddNew',
      onClick: handleAdd,
      disabled,
    },
    {
      type: 'ghost',
      className: 'btnRadius10',
      icon: 'ReloadOutlined',
      content: 'Refresh',
      id: 'btnRefreshList',
      onClick: handleRefresh,
      disabled,
    },
  ];
  return (
    <div className="padding16">
      <Row gutter={20}>
        <Col span={4}>
          <label className="labelBtnFilter">Status</label>
          <Select
            dataOption={filterStatus || []}
            idComponent="filterChannel"
            meta={{ touched: false, error: false }}
            input={{
              onBlur: null,
              onChange: setSelectedStatus,
              value: selectedStatus ? selectedStatus : 'Semua',
            }}
            defaultItemName="Semua"
          />
        </Col>
        <Col span={8} className={'btnFilterAplicationList'}>
          <CButton
            buttonData={buttonDataSearch}
            isLoading={isLoading}
            buttonFloat={'left'}
          />
        </Col>
        <Col span={12} className={'btnFilterAplicationList'}>
          <CButton
            buttonData={buttonData}
            isLoading={isLoading}
            buttonFloat={'right'}
          />
        </Col>
      </Row>
      <Table
        isLoading={isLoading}
        columns={generateColumnData(columnData)}
        data={data}
        pagination={true}
        useFilterGlobal={true}
      />
    </div>
  );
}
